import toCamelCase from 'lodash-es/camelCase';
import isPlainObject from 'lodash-es/isPlainObject';

// Use custom snakecase because we want 'asdfS3Asdf' to convert to 
// 'asdf_s3_asdf' not 'asdf_s_3_asdf' as snakecase from lodash would.
const toCustomSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const camelCaseKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(camelCaseKeys);
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  return Object.entries(obj).reduce((memo, [key, value]) => (
    { ...memo, [toCamelCase(key)]: camelCaseKeys(value) }
  ), {});
};

export const snakeCaseKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(snakeCaseKeys);
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  return Object.entries(obj).reduce((memo, [key, value]) => (
    { ...memo, [toCustomSnakeCase(key)]: snakeCaseKeys(value) }
  ), {});
};

export const encodeObjectForQueryString = object => btoa(JSON.stringify(object));
export const decodeObjectFromQueryString = string => JSON.parse(atob(string));
